module.exports = __webpack_public_path__ + "img/app_trash@2x.4b265acd.png";